// extracted by mini-css-extract-plugin
module.exports = {"videoIframe":"hYcJg9","videoLazy":"_31Tz38","videoLogo":"DmFv5C"};